const formatters = new Map<string, Intl.NumberFormat>();

export function formatMoney(cents: number, currency = 'usd'): string {
  const normalized = currency.toUpperCase();
  let formatter = formatters.get(normalized);
  if (!formatter) {
    formatter = new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: normalized,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    formatters.set(normalized, formatter);
  }
  return formatter.format(cents / 100);
}
